import { type FC } from "react";

import { ConfirmDialog } from "@styled/confirm_dialog";
import { ErrorLine } from "@styled/error_line";

import { useDraftingSectionsOf } from "./use_drafting_sections";

// Asks before a section goes: from his template, so new cases won't have it,
// or from this case only. Its heading and what's drafted for it go too; the chat keeps it.
export const DraftingSectionRemove: FC<{
  section: { id: string; name: string };
  onClose(): void;
}> = ({ section, onClose }) => {
  const drafting = useDraftingSectionsOf();
  return (
    <ConfirmDialog
      title={
        drafting.onTemplate
          ? `Remove ${section.name} from your template?`
          : `Remove ${section.name} from this case?`
      }
      action="Remove"
      loading={drafting.removing}
      onClose={onClose}
      onConfirm={() => {
        void drafting.removeSection(section.id).then((removed) => {
          if (removed) onClose();
        });
      }}
    >
      {drafting.onTemplate && "New cases won't have it. "}
      Its heading and drafted text come out of this case too.
      {drafting.removeError && <ErrorLine>{drafting.removeError}</ErrorLine>}
    </ConfirmDialog>
  );
};
